// Order is the section order in the Invoicing Settings modal.
export enum InvoicingSettingsSection {
  LogoAndBranding = 'logoAndBranding',
  PaymentsAndReminders = 'paymentsAndReminders',
  Presets = 'presets',
  Compliance = 'compliance',
  EInvoicing = 'eInvoicing',
  Invoice = 'invoice',
  Quote = 'quote',
}
